import { exportCallsDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const exportCallsCallable = getCallable(exportCallsDefinition);
